import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import moment from 'moment';
import { companyUpdated } from '../../actions/company';
import { loadPaymentData } from '../../actions/payment';
import NavBarConfig from '../../components/NavBarConfig';
import NotFound from '../../components/NotFound';
import PaymentInfo from './components/PaymentInfo';

const messages = defineMessages({
  BACK: {
    id: 'CompanyPaymentPage.BACK',
    defaultMessage: 'Zurück',
  },
  MAINTAIN_ACCOUNT: {
    id: 'CompanyPaymentPage.MAINTAIN_ACCOUNT',
    defaultMessage: 'Nutzerkonto verwalten',
  },
  TEXT_1: {
    id: 'CompanyPaymentPage.TEXT_1',
    defaultMessage: 'Sie haben noch kein Nutzerkonto angelegt. Ihr kostenloses Test-Nutzerkonto ist abgelaufen.',
  },
  TEXT_2: {
    id: 'CompanyPaymentPage.TEXT_2',
    defaultMessage: 'Um tele-LOOK auch nach der kostenlosen Testphase nutzen zu können, kontaktieren Sie uns bitte unter +49 731 85 07 42 20 oder per E-Mail ',
  },
  /*TEXT_3: {
    id: 'CompanyPaymentPage.TEXT_3',
    defaultMessage: 't ',
  },*/
  TEXT_4: {
    id: 'CompanyPaymentPage.TEXT_4',
    defaultMessage: 'Sie haben noch kein Nutzerkonto angelegt. Ihr kostenloses Test-Nutzerkonto '
      + 'läuft {expirationDate} ab.',
  },
  TEXT_5: {
    id: 'CompanyPaymentPage.TEXT_5',
    defaultMessage: 'Das Anlegen eines Nutzerkontos und der Zugriff auf bestehende Videodialoge und dessen gespeicherten Bilder und Notizen sind kostenlos. '
      + 'Während des tele-LOOK Testzeitraum bleibt auch beim Anlegen eines Nutzerkontos alles kostenlos.',
  },
  TEXT_6: {
    id: 'CompanyPaymentPage.TEXT_6',
    defaultMessage: 'Um tele-LOOK auch nach der kostenlosen Testphase nutzen zu können, kontaktieren Sie uns bitte unter +49 731 85 07 42 20 '
      + 'oder per E-Mail `<a href=\"mailto:sales@tele-look.com\"`>sales@tele-look.com`</a`>.',
  },
  TEXT_7: {
    id: 'CompanyPaymentPage.TEXT_7',
    defaultMessage: 'Handwerksunternehmen kontaktieren bitte ihre Innung oder ihren Verband.',
  },
  EDIT_DATA: {
    id: 'CompanyPaymentPage.EDIT_DATA',
    defaultMessage: 'Daten bearbeiten',
  },
  CREATE_ACCOUNT: {
    id: 'CompanyPaymentPage.CREATE_ACCOUNT',
    defaultMessage: 'Nutzerkonto anlegen',
  },
});

class CompanyPaymentPage extends React.Component {
  componentWillMount() {
    const { company } = this.props;
    if (company.hasPaymentData && !company.payment) {
      this.props.loadPaymentData();
    }
  }

  render() {
    const { user, company, companyMembership, routes, intl: { formatMessage } } = this.props;
    const trialDays = company.trial_days || 14;
    const expirationDate = moment(company.created).add(trialDays, 'days');
    const isGlobalAdmin = user && user.is_admin;
    const isCompanyAdmin = companyMembership && (companyMembership.is_owner || companyMembership.is_admin);
    if (!isGlobalAdmin && !isCompanyAdmin) {
      return <NotFound />;
    }
    return (
      <div style={{ padding: '16px', backgroundColor: 'transparent', minHeight: '100vh', width: '100%' }}>
        <NavBarConfig
          customerList={{ company_id: company.id }}
          currentRouteName={routes[routes.length - 1].name}
        />
        
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
          {/* Header */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '32px', flexWrap: 'wrap', gap: '16px' }}>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: 'var(--panel-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', fontSize: '18px', border: '1px solid var(--panel-border)' }}>
                <i className="fa fa-credit-card" />
              </div>
              <div>
                {formatMessage(messages.MAINTAIN_ACCOUNT)}
                <span style={{ display: 'block', fontSize: '14px', fontWeight: 'normal', color: 'var(--text-muted)', marginTop: '4px' }}>
                  {company.name}
                </span>
              </div>
            </h2>
          </div>

          {/* Main Card */}
          <div style={{ maxWidth: '800px', backgroundColor: 'var(--panel-bg)', borderRadius: '12px', border: '1px solid var(--panel-border)', boxShadow: '0 4px 6px -1px var(--panel-shadow)', padding: '32px', overflow: 'hidden' }}>
            <div style={{ color: 'var(--text-muted)', fontSize: '16px', lineHeight: '1.7' }}>
              {!company.hasPaymentData && company.isExpired ? (
                <p style={{ marginBottom: '20px' }}>
                  {formatMessage(messages.TEXT_1)}
                  <br /> <br />
                  {formatMessage(messages.TEXT_2)} <a href="mailto:sales@tele-look.com" style={{ color: 'var(--card-text-hover)', fontWeight: 'bold', textDecoration: 'none' }}>sales@tele-look.com</a>.
                </p>
              ) : null
              }
              {!company.hasPaymentData && !company.isExpired ? (
                <p style={{ marginBottom: '20px' }}>
                  {formatMessage(messages.TEXT_4, { expirationDate: <strong style={{ color: 'var(--text-color)' }}>{expirationDate.fromNow()}</strong> })}
                  <br /> <br />
                  {formatMessage(messages.TEXT_5)}
                  <br /> <br />
                  {formatMessage(messages.TEXT_6)} <a href="mailto:sales@tele-look.com" style={{ color: 'var(--card-text-hover)', fontWeight: 'bold', textDecoration: 'none' }}>sales@tele-look.com</a>.
                  <br /> <br />
                  {formatMessage(messages.TEXT_7)}
                </p>
              ) : null
              }
              {company.hasPaymentData && company.payment !== undefined ? (
                <PaymentInfo payment={company.payment} />
              ) : null}
            </div>

            {(user.is_admin || companyMembership.is_owner) && (
              <div style={{ textAlign: 'left', marginTop: '40px' }}>
                <Link 
                  to={`/company/${company.id}/payment/edit`} 
                  className="lh-btn lh-btn-primary"
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '14px 36px',
                    fontSize: '16px',
                    fontWeight: '600',
                    borderRadius: '50px',
                    boxShadow: '0 4px 14px rgba(2, 117, 216, 0.3)',
                    transition: 'all 0.2s ease',
                    textDecoration: 'none',
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px'
                  }}
                >
                  {company.hasPaymentData ? formatMessage(messages.EDIT_DATA) : formatMessage(messages.CREATE_ACCOUNT)}
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default connect(null,
  (dispatch, props) => ({
    loadPaymentData: () => loadPaymentData(props.company.id)
      .then(response => dispatch(companyUpdated({ ...props.company, payment: response }))),
  })
)(injectIntl(CompanyPaymentPage));
